var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 34,
    viewBox: "0 0 100 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.6433 17.4988L86.6205 22.4035H96.2474V24.4566H83.8374V8.48792H96.1789V10.541H86.6433V15.4457H96.1789V17.4988H86.6433Z",
    fill: "url(#paint0_linear_1283_6135)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7902 22.2895L82.7674 24.4566H75.1936V8.48792H78.1364L77.9996 22.2895H82.7902Z",
    fill: "url(#paint1_linear_1283_6135)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6327 15.902C71.4577 15.902 74.1724 16.7004 74.1724 19.9854C74.1724 23.1107 71.6859 24.4794 68.7887 24.4566H63.7699V8.48792H68.3781C71.2752 8.30542 73.8074 9.42323 73.8074 12.3204C73.8074 15.1263 71.4577 15.8563 69.6327 15.8563V15.902ZM66.5759 14.8754H68.3781C69.9065 14.8754 71.0015 14.191 71.0015 12.5713C71.0015 11.0657 69.9065 10.5182 68.3781 10.541H66.5759V14.8754ZM66.5759 22.4035H68.8115C70.4084 22.4263 71.3665 21.3998 71.3665 19.6432C71.3665 17.9095 69.9065 16.9057 68.3781 16.9285H66.5759V22.4035Z",
    fill: "url(#paint2_linear_1283_6135)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0037 15.902C59.8287 15.902 62.5434 16.7004 62.5434 19.9854C62.5434 23.1107 60.0569 24.4794 57.1597 24.4566H52.1409V8.48792H56.7491C59.6462 8.30542 62.1784 9.42323 62.1784 12.3204C62.1784 15.1263 59.8287 15.8563 58.0037 15.8563V15.902ZM54.9469 14.8754H56.7491C58.2775 14.8754 59.3725 14.191 59.3725 12.5713C59.3725 11.0657 58.2775 10.5182 56.7491 10.541H54.9469V14.8754ZM54.9469 22.4035H57.1825C58.7794 22.4263 59.7375 21.3998 59.7375 19.6432C59.7375 17.9095 58.2775 16.9057 56.7491 16.9285H54.9469V22.4035Z",
    fill: "url(#paint3_linear_1283_6135)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4124 8.48792L50.4352 24.4566H47.6064V8.48792H50.4124Z",
    fill: "url(#paint4_linear_1283_6135)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7016 8.48792V16.4038L43.1044 8.48792H45.9103L41.6216 16.1985H46.1384L42.2147 24.4566H39.4087L42.6709 17.9779H38.7244V24.4566H35.8956V8.48792H38.7016Z",
    fill: "url(#paint5_linear_1283_6135)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.3742,
    y: 21.2185,
    width: 4.15092,
    height: 4.15092,
    rx: 1.20758,
    fill: "#FF394A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1402 8.70862H12.7447C12.3187 8.70862 11.9311 8.95479 11.75 9.34034L4.95684 23.8033C4.61453 24.5321 5.14632 25.3694 5.95148 25.3694H10.42C10.8476 25.3694 11.2364 25.1213 11.4166 24.7335L18.1368 10.2706C18.4752 9.54218 17.9434 8.70862 17.1402 8.70862Z",
    fill: "#FF394A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2968 8.70862H30.6492C31.4514 8.70862 31.9833 9.54044 31.6466 10.2687L28.792 16.4433C28.6123 16.8321 28.2229 17.0811 27.7946 17.0811H21.7235L24.9391 23.7958C25.2884 24.5253 24.7567 25.3694 23.948 25.3694H19.5607C19.1346 25.3694 18.747 25.1231 18.5659 24.7374L15.7073 18.6469C15.3652 17.9181 15.897 17.0811 16.702 17.0811H21.7235L25.2993 9.34638C25.4791 8.95755 25.8684 8.70862 26.2968 8.70862Z",
    fill: "#FF394A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1283_6135",
    x1: 35.8956,
    y1: 16.4629,
    x2: 96.2474,
    y2: 16.4629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF394A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99222C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1283_6135",
    x1: 35.8956,
    y1: 16.4629,
    x2: 96.2474,
    y2: 16.4629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF394A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99222C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1283_6135",
    x1: 35.8956,
    y1: 16.4629,
    x2: 96.2474,
    y2: 16.4629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF394A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99222C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1283_6135",
    x1: 35.8956,
    y1: 16.4629,
    x2: 96.2474,
    y2: 16.4629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF394A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99222C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1283_6135",
    x1: 35.8956,
    y1: 16.4629,
    x2: 96.2474,
    y2: 16.4629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF394A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99222C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1283_6135",
    x1: 35.8956,
    y1: 16.4629,
    x2: 96.2474,
    y2: 16.4629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF394A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99222C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3c99d87a4b7a33b40dd29131dde6ace2.svg";
export { ForwardRef as ReactComponent };